"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));
var _ref = /*#__PURE__*/
_react.default.createElement("path", {
  d: "M1280 1493.667v-213.334h106.667v213.334c0 88.213-71.787 160-160 160H160c-88.213 0-160-71.787-160-160V427c0-88.213 71.787-160 160-160h1066.667c88.213 0 160 71.787 160 160v426.667H1280v-160H106.667v800C106.667 1523 130.56 1547 160 1547h1066.667c29.44 0 53.333-24 53.333-53.333zm624.373-464.374c20.8 20.8 20.8 54.614 0 75.414l-320 320-75.413-75.414 228.907-228.906H906.613V1013.72h831.254L1508.96 784.707l75.413-75.414 320 320zM160 373.667c-29.44 0-53.333 24-53.333 53.333v160H1280V427c0-29.333-23.893-53.333-53.333-53.333H160z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});
var IconExternalLink = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconExternalLink, _Component);
  function IconExternalLink() {
    (0, _classCallCheck2.default)(this, IconExternalLink);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconExternalLink).apply(this, arguments));
  }
  (0, _createClass2.default)(IconExternalLink, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconExternalLink",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);
  IconExternalLink.displayName = "IconExternalLink";
  return IconExternalLink;
}(_react.Component);
exports.default = IconExternalLink;
IconExternalLink.glyphName = 'external-link';
IconExternalLink.variant = 'Line';
IconExternalLink.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);